import React, { useEffect } from 'react';
import {
  FiAlertCircle,
  FiCheckCircle,
  FiInfo,
  FiXCircle,
} from 'react-icons/fi';
import { ToastMessage, useToast } from '../../../hooks/toast';
import { Container } from './styles';

interface ToastProps {
  message: ToastMessage;
  style: object;
}

const icons = {
  info: <FiInfo size={24} />,
  error: <FiAlertCircle size={24} />,
  success: <FiCheckCircle size={24} />,
};

const Toast: React.FC<ToastProps> = ({ message, style }) => {
  const { removeToast, callToast } = useToast();

  useEffect(() => {

    // const timerToast = setTimeout(() => {
    //   callToast(message.id);
    // }, 1000);

    const timer = setTimeout(() => {
      removeToast(message.id);
    }, 10000);

    return () => {
      clearTimeout(timer);
    };
  }, [removeToast, message.id,  message]);

  useEffect(() => {

    const timerToast = setTimeout(() => {
      callToast(message.id);
    }, 1000);

    return () => {
      clearTimeout(timerToast);
    };
  }, [message.id, callToast, message]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     removeToast(message.id);
  //   }, 1000);

  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, [removeToast, message.id]);

  return (
    <Container
      type={message.type}
      hasdescription={!!message.description}
      style={style}
    >
      {icons[message.type || 'info']}

      <div>
        <strong>{message.title}</strong>
        {message.description && <p>{message.description}</p>}
      </div>

      <button onClick={() => removeToast(message.id)} type="button">
        <FiXCircle size={18} />
      </button>
    </Container>
  );
};

export default Toast;
